import {UserConfig} from './UserConfig';
import {TInitModule} from "../../interface"


export function init(): TInitModule {
    return {
        component: UserConfig,
        buttonFunctions: []
    }
}
